<template>
    <div class="page-break-settings">
        <div class="setting-group">
            <label class="setting-label">Buton Hizalaması</label>
            <select
                v-model="localAlign"
                @change="updateField"
                class="setting-select"
            >
                <option value="left">Sol</option>
                <option value="center">Orta</option>
                <option value="right">Sağ</option>
            </select>
        </div>

        <div class="setting-group">
            <label class="setting-label">Devam Butonu Metni</label>
            <input
                type="text"
                v-model="localNextButtonText"
                @input="updateField"
                class="setting-input"
                placeholder="Devam"
                ref="nextButtonTextInput"
            />
        </div>

        <div class="setting-group">
            <label class="setting-label">Geri Butonu Metni</label>
            <input
                type="text"
                v-model="localPreviousButtonText"
                @input="updateField"
                class="setting-input"
                placeholder="Geri"
                ref="previousButtonTextInput"
            />
        </div>

        <div class="setting-group">
            <label class="setting-label checkbox-label">
                <input
                    type="checkbox"
                    v-model="localShowPreviousButton"
                    @change="updateField"
                    class="setting-checkbox"
                />
                Geri Butonunu Göster
            </label>
        </div>

        <div class="setting-group">
            <label class="setting-label checkbox-label">
                <input
                    type="checkbox"
                    v-model="localShowNextButton"
                    @change="updateField"
                    class="setting-checkbox"
                />
                Devam Butonunu Göster
            </label>
        </div>

        <div class="setting-group">
            <label class="setting-label checkbox-label">
                <input
                    type="checkbox"
                    v-model="localVisibility"
                    @change="updateField"
                    class="setting-checkbox"
                />
                Alan Görünür
            </label>
        </div>

        <div class="setting-group">
            <label class="setting-label">URL Parametresi</label>
            <input
                type="text"
                v-model="localSlug"
                @input="setSlug($event.target.value)"
                class="setting-input"
                placeholder="pagebreak"
                ref="slugInput"
            />
            <small style="font-size: 0.75rem; color: #6b7280; margin-top: 0.25rem; display: block;">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "PageBreakSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localAlign: "center",
            localNextButtonText: "Devam",
            localPreviousButtonText: "Geri",
            localShowPreviousButton: true,
            localShowNextButton: true,
            localVisibility: true,
            localSlug: '',
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions({
            updateFormField: "forms/updateFormField",
        }),

        setSlug(slug) {
            this.localSlug = this.sanitizeSlug(slug);
            this.updateField();
        },

        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },

        updateField() {
            const self = this;

            if (self.updateTimer) {
                clearTimeout(self.updateTimer);
            }

            self.updateTimer = setTimeout(() => {
                self.$emit("update-pagebreak-align", self.localAlign);
                self.$emit("update-pagebreak-next-button-text", self.localNextButtonText);
                self.$emit("update-pagebreak-previous-button-text", self.localPreviousButtonText);
                self.$emit("update-pagebreak-show-previous-button", self.localShowPreviousButton);
                self.$emit("update-pagebreak-show-next-button", self.localShowNextButton);

                const updateFields = {
                    visibility: self.localVisibility,
                    slug: self.localSlug,
                    pagebreak: {
                        fieldLabel: "Sayfa Sonu",
                        align: self.localAlign,
                        nextButtonText: self.localNextButtonText,
                        previousButtonText: self.localPreviousButtonText,
                        showPreviousButton: self.localShowPreviousButton,
                        showNextButton: self.localShowNextButton,
                    },
                };

                console.log("🔴 PageBreak settings updating:", {
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                    item: self.item,
                });

                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                console.log("🔴 PageBreak settings updateFormField called");
            }, 800);
        },
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler: function(val, oldVal) {
                if (!val) return;

                console.log("🔴 PageBreakSettings item watcher:", {
                    val,
                    oldVal,
                    align: val.align,
                    nextButtonText: val.nextButtonText,
                    previousButtonText: val.previousButtonText,
                });

                const isInitialLoad = !oldVal || oldVal !== val;

                if (isInitialLoad) {
                    const nextButtonTextInput = this.$refs.nextButtonTextInput;
                    const previousButtonTextInput = this.$refs.previousButtonTextInput;

                    this.localAlign = val.align || "center";

                    if (!nextButtonTextInput || document.activeElement !== nextButtonTextInput) {
                        this.localNextButtonText = val.nextButtonText || "Devam";
                    }

                    if (!previousButtonTextInput || document.activeElement !== previousButtonTextInput) {
                        this.localPreviousButtonText = val.previousButtonText || "Geri";
                    }

                    this.localShowPreviousButton = val.showPreviousButton !== undefined ? val.showPreviousButton : true;
                    this.localShowNextButton = val.showNextButton !== undefined ? val.showNextButton : true;

                    this.localVisibility = val.visibility !== undefined ? val.visibility : true;
                    
                    const slugInput = this.$refs.slugInput;
                    if (!slugInput || document.activeElement !== slugInput) {
                        this.localSlug = val.slug || '';
                    }

                    console.log("🔴 PageBreakSettings watcher updated values:", {
                        localAlign: this.localAlign,
                        localNextButtonText: this.localNextButtonText,
                        localPreviousButtonText: this.localPreviousButtonText,
                        localShowPreviousButton: this.localShowPreviousButton,
                        localShowNextButton: this.localShowNextButton,
                    });
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.page-break-settings {
    padding: 20px;
}

.setting-group {
    margin-bottom: 20px;
}

.setting-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;

    &.checkbox-label {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
    }
}

.setting-input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background-color: #ffffff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
}

.setting-select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background-color: #ffffff;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
}

.setting-checkbox {
    width: 18px;
    height: 18px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    cursor: pointer;
    accent-color: #3b82f6;

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
}
</style>
